var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unsupported"},[_c('BaseText3',{staticClass:"title",attrs:{"text":_vm.title}}),(_vm.subtitle)?_c('BaseText6',{staticClass:"subtitle",attrs:{"text":_vm.subtitle}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }